module.exports = __webpack_public_path__ + "img/icon_map_5.1881899d.png";